module.exports = __webpack_public_path__ + "83544871d0e617c8b68a36c29b7e5e10.svg";